import {
  CountryCode,
  countryCode as countryCodeEnum,
} from "shared/types/countryCode";

const DROPS_SE_CONTEXT_TYPE = "DROPS_SE";
const DROPS_CONTEXT_TYPE = "DROPS";
export const OPLOG_CONTEXT_TYPE = "DROPS_LOG";

export const getDropsContextType = (countryCode: CountryCode) => {
  switch (countryCode) {
    case countryCodeEnum.enum.SE:
      return DROPS_SE_CONTEXT_TYPE;
    case countryCodeEnum.enum.NO:
      return DROPS_CONTEXT_TYPE;
  }
};

export const isDropsContextType = (type: string) =>
  type === DROPS_CONTEXT_TYPE || type === DROPS_SE_CONTEXT_TYPE;

export const FILTERED_CONTEXT_TYPES = ["KARI_ANNOUNCEMENT", "KARI_DISPLAY"];
